export default "__VITE_ASSET__Ne_$oo_4__"